import { render } from "./UiPropIconSelector.vue?vue&type=template&id=4eafdbe6"
import script from "./UiPropIconSelector.vue?vue&type=script&lang=js"
export * from "./UiPropIconSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__